// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_vm-8";
export var editMode = "_vm-3";
export var headerRow = "_vm-a";
export var headerTitle = "_vm-b";
export var product = "_vm-1";
export var productDetails = "_vm-5";
export var productDivider = "_vm-7";
export var productImage = "_vm-2";
export var productInfo = "_vm-4";
export var productTitle = "_vm-6";
export var strikethrough = "_vm-9";
export var upsellProductsCard = "_vm-0";